import PageTitle from "../../../ui/PageTitle/PageTitle";
import WelcomeCard from "../../../ui/WelcomeCard/WelcomeCard";

import { createStructuredSelector } from "reselect";
import { selectUserInfo } from "../../../App/module/selectors";

import { IUserInfo, UserSections } from "../../../models/User";

import { FormattedMessage } from "react-intl";
import messages from "./module/messages";

import { connect } from "react-redux";
import { ROUTES } from "../../../module/constants";

import { push } from "connected-react-router";
import {
  FaBell,
  FaClock,
  FaQuestion,
  FaRegEdit,
  FaUnlockAlt,
  FaUser,
  FaFileCsv,
} from "react-icons/fa";
import {
  MdMail,
  MdMenuBook,
  MdMobileFriendly,
  MdNotes,
  MdOutlineAddTask,
  MdOutlineAnalytics,
  MdOutlineFactCheck,
  MdOutlineLibraryBooks,
  MdOutlineManageSearch,
  MdOutlinePersonAddAlt,
  MdOutlinePersonSearch,
  MdOutlinePostAdd,
  MdOutlineSettings,
  MdTableChart,
  MdWork,
  MdWysiwyg,
} from "react-icons/md";
import OutlinedButton from "../../../ui/OutlinedButton/OutlinedButton";
import classes from "./AdminWelcome.module.scss";
import { RiRobotLine } from "react-icons/ri";
import { CONSOLE_ADMIN_DASHBOARD_CARDS } from "../adminConstants";

interface IAdminWelcomeProps {
  userInfo: IUserInfo;
  changeLocation: (url: string) => {};
}

function AdminWelcome(props: IAdminWelcomeProps) {
  const { userInfo, changeLocation } = props;

  return (
    <>
      <OutlinedButton onClick={() => changeLocation(ROUTES.WELCOME)}>
        {<FormattedMessage {...messages.backToHomepage} />}
      </OutlinedButton>
      <PageTitle title={messages.pageTitle} />
      <div className={classes["welcome-wrapper"]}>
        <div className="container">
          <div className={`row p-3 m-3 ${classes["section-welcome-nav"]}`}>
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left p-1">
              <FormattedMessage {...messages.panelTitleConsoleAdmin} />
            </div>
            <hr />
            <div className={`${classes["section-welcome-nav-body"]}`}>
              {CONSOLE_ADMIN_DASHBOARD_CARDS.map((card) => (
                <>
                  {userInfo.sections.includes(card.sectionCode) && (
                    <div
                      key={card.sectionCode}
                      className="d-flex justify-content-center"
                    >
                      <WelcomeCard
                        title={card.title}
                        desc={card.description}
                        icon={card.icon}
                        url={card.url}
                      />
                    </div>
                  )}
                </>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps: any = () =>
  createStructuredSelector({
    userInfo: selectUserInfo,
  });

const mapDispatchToProps: any = {
  changeLocation: (url: any) => push(url),
};

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(AdminWelcome);
